import { render, staticRenderFns } from "./standingBook.vue?vue&type=template&id=08c0b325&scoped=true"
import script from "./standingBook.vue?vue&type=script&lang=js"
export * from "./standingBook.vue?vue&type=script&lang=js"
import style0 from "./standingBook.vue?vue&type=style&index=0&id=08c0b325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0b325",
  null
  
)

export default component.exports